import { cn } from "@forento/ui/utilities/tailwind"

import { usePlatform, useUser } from "~/contexts/UserContext"

const WorkspaceIdentity = ({ className }: { className?: string }) => {
	const platform = usePlatform()!
	const { user } = useUser()
	const initials = platform.name
		.trim()
		.split(/\s+/)
		.slice(0, 2)
		.map(word => Array.from(word)[0])
		.join("")
		.toUpperCase()

	return (
		<div
			className={cn("flex min-w-0 items-center gap-2.5", className)}
			title={`${platform.name}\nSigned in as ${user!.email}`}
		>
			<div
				aria-hidden="true"
				className="bg-primary/8 text-primary ring-primary/10 flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-lg text-xs font-semibold ring-1 ring-inset"
			>
				{platform.logo?.isIcon ? (
					<img src={platform.logo.filePath} alt="" className="size-full object-contain p-1" />
				) : (
					initials
				)}
			</div>
			<div className="min-w-0 truncate text-sm font-semibold text-slate-800">{platform.name}</div>
			<span className="sr-only">Signed in as {user!.email}</span>
		</div>
	)
}

export default WorkspaceIdentity
